// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__2bhYs"};